import React, { useEffect, useRef, useState } from "react";

import DashboardLineChart from "../../CommonComponents/Dashboard/DashboardLineChart/DashboardLineChart";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

import dayjs from "dayjs";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import { formatDateArrayWithHour } from "../../../utils/DateFormatter";

const PROMOS_OPTIONS = {
  total_free_play_cash: "Total free play cash",

  total_free_cash_paid_out: "Total free cash paid out",
  total_paid_out: "Total free cash paid out",

  total_rebet_free_cash_bets: "Total rebet free cash bets",
  total_count: "Total rebet free cash bets",

  total_rebet_free_cash_wagered: "Total rebet free cash wagered",
  total_wagered: "Total rebet free cash wagered",
};

const getKeyByValue = (object, value) =>
  Object.keys(object).find((key) => object[key] === value);

function Promos({
  isApiRunning,
  setIsApiRunning,
  promosData,
  setPromosData,
  isPromoDataFirstRender,
  promoSectionDates,
  setPromoSectionDates,
}) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken,
    true
  );

  const [selected, setSelected] = useState(PROMOS_OPTIONS.total_free_play_cash);
  const selectedKey = getKeyByValue(PROMOS_OPTIONS, selected);

  const queryString = `start_date=${promoSectionDates[0].format(
    "YYYY-MM-DD"
  )}&end_date=${promoSectionDates[1].format("YYYY-MM-DD")}`;

  const labels = formatDateArrayWithHour(
    Object.keys(promosData?.ts_agg_data?.[selectedKey] ?? {})
  );
  const headers = [
    { title: "Total free play cash" },
    { title: "Total rebet free cash bets" },
    { title: "Total rebet free cash wagered" },
    { title: "Total free cash paid out" },
  ];

  const kpis = {
    labels: labels,
    datasets: [
      {
        label: "Kpis",
        data: Object.values(promosData?.ts_agg_data?.[selectedKey] ?? {}),
        borderColor: "#EE72BC",
        backgroundColor: "#EE72BC",
        borderRadius: 1,
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    headers: Object.keys(promosData?.metric_agg || {})?.map((key) => ({
      title: PROMOS_OPTIONS[key],
      amount: promosData?.metric_agg[key].current,
      percentage: promosData?.metric_agg[key].change,
    })),
  };

  const getPromosData = async (queryString) => {
    setIsApiRunning(true);

    const url = "dashboard/finance/promos?" + queryString;

    try {
      const response = await PrivateAdminPanelInstance?.get(url);
      const data = response?.data.data;

      setPromosData(data);
    } catch (error) {
      console.log("error getting promo data", error);
    } finally {
      setIsApiRunning(false);
    }
  };


  useEffect(() => {
    if (isPromoDataFirstRender.current) {
      getPromosData(queryString);
      isPromoDataFirstRender.current = false;
    }
  }, []);

  return (
    <DashboardLineChart
      headers={Object.keys(kpis.headers).length === 0 ? headers : kpis.headers}
      title={false}
      data={kpis}
      rightInfo={false}
      setSelected={setSelected}
      configOptions={PROMOS_OPTIONS}
      isApiRunning={isApiRunning}
      getData={getPromosData}
      dates={promoSectionDates}
      setDates={setPromoSectionDates}
    />
  );
}

export default Promos;
